export const EXTERNAL_NAVIGATION_EN = {
  externalNavigation: {
    leaveTitle: 'Leave Newsrooms AI?',
    openExternalDescription: 'You are about to open an external website:',
    fallbackDisplayUrl: 'External URL',
    unknownUrl: 'Unknown URL',
    visitExternalUrl: 'Visit External URL',
    sourceFallback: 'Source'
  }
}

export const EXTERNAL_NAVIGATION_DE = {
  externalNavigation: {
    leaveTitle: 'Newsrooms AI verlassen?',
    openExternalDescription: 'Sie sind dabei, eine externe Website zu öffnen:',
    fallbackDisplayUrl: 'Externe URL',
    unknownUrl: 'Unbekannte URL',
    visitExternalUrl: 'Externe URL besuchen',
    sourceFallback: 'Quelle'
  }
}
